import dispatcher from "../Dispatcher/Dispatcher";
import config from "../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import reparaturconstants from "../Constants/ReparaturContstants";

class ReparaturActions {
  getRueckmeldungsvorlage(anlagegruppeId) {
    httpRequest(
      config.webServiceURL +
        "/VorlageManagement/rueckmeldungsvorlage?anlagegruppeId=" +
        anlagegruppeId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: reparaturconstants.GET_RUECKMELDUNGVORLAGE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: reparaturconstants.GET_RUECKMELDUNGVORLAGE_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getReparaturen(anlageid) {
    httpRequest(
      config.webServiceURL + "/Anlage/ReparaturList?anlageid=" + anlageid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: reparaturconstants.GET_REPARTURLIST_SUCCES,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: reparaturconstants.GET_REPARTURLIST_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  addReparatur(reparatur) {
    httpRequest(
      config.webServiceURL + "/Anlage/addReparatur",
      "PUT",
      JSON.stringify(reparatur),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: reparaturconstants.ADD_REPARATUR_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: reparaturconstants.ADD_REPARATUR_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new ReparaturActions();
